import React from "react";
import "./App.css";
import { Toaster } from "sonner";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Terrains from "./components/Terrains";
import Pricing from "./components/Pricing";
import Events from "./components/Events";
import Reviews from "./components/Reviews";
import Maps from "./components/Maps";
import Footer from "./components/Footer";
import StickyCallBar from "./components/StickyCallBar";
import FloatingSocials from "./components/FloatingSocials";
import MentionsLegales from "./pages/MentionsLegales";

function Landing() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <Terrains />
        <Pricing />
        <Events />
        <Reviews />
        <Maps />
      </main>
      <Footer />
      <StickyCallBar />
      <FloatingSocials />
    </>
  );
}

export default function App() {
  return (
    <div className="App font-body bg-white text-black">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/mentions-legales" element={<MentionsLegales />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-center" richColors />
    </div>
  );
}
